var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fileBox" },
    [
      _vm._l(_vm.tasksItem.fileList, function (item, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "fileItem m-r-8 m-b-8",
            class: !_vm.isImageFile(item.fileURL || item.fileUrl)
              ? "width-100 cor167CDB"
              : "",
            on: {
              click: function ($event) {
                return _vm.handleFileClick(item)
              },
            },
          },
          [
            _vm.isImageFile(item.fileURL || item.fileUrl)
              ? _c(
                  "div",
                  { staticClass: "fileContainer" },
                  [
                    _c("van-image", {
                      attrs: {
                        width: "80",
                        height: "80",
                        fit: "cover",
                        src: item.fileURL || item.fileUrl,
                      },
                    }),
                  ],
                  1
                )
              : _c("div", { staticClass: "" }, [
                  _vm._v(" " + _vm._s(item.fileName) + " "),
                ]),
          ]
        )
      }),
      _c("van-image-preview", {
        attrs: {
          images: _vm.currentImageList,
          "start-position": _vm.currentImageIndex,
        },
        on: { change: _vm.onImageChange },
        model: {
          value: _vm.showImagePreview,
          callback: function ($$v) {
            _vm.showImagePreview = $$v
          },
          expression: "showImagePreview",
        },
      }),
      _c(
        "van-popup",
        {
          staticClass: "filePreviewStyle",
          style: { height: "90%", width: "100%", bottom: "0" },
          attrs: { position: "bottom", round: "", closeable: "" },
          on: { close: _vm.closePdfPreview },
          model: {
            value: _vm.showPdfPreview,
            callback: function ($$v) {
              _vm.showPdfPreview = $$v
            },
            expression: "showPdfPreview",
          },
        },
        [
          _c("div", { staticClass: "title font-28 cor-33 p-24 text-center" }, [
            _vm._v(_vm._s(_vm.selectedFile ? _vm.selectedFile.fileName : "")),
          ]),
          _c("div", { staticClass: "pdfPreviewContainer" }, [
            _c("iframe", {
              attrs: { src: _vm.currentPdfUrl, frameborder: "0" },
              on: { load: _vm.onPdfLoaded },
            }),
          ]),
        ]
      ),
      _c(
        "van-popup",
        {
          staticClass: "filePreviewStyle",
          style: { height: "90%", width: "100%", bottom: "0" },
          attrs: { position: "bottom", round: "", closeable: "" },
          on: { close: _vm.closeOfficePreview },
          model: {
            value: _vm.showOfficePreview,
            callback: function ($$v) {
              _vm.showOfficePreview = $$v
            },
            expression: "showOfficePreview",
          },
        },
        [
          _c("div", { staticClass: "title font-28 cor-33 p-24 text-center" }, [
            _vm._v(_vm._s(_vm.selectedFile ? _vm.selectedFile.fileName : "")),
          ]),
          _c("div", { staticClass: "officePreviewContainer" }, [
            _c("iframe", {
              attrs: { src: _vm.currentOfficeUrl, frameborder: "0" },
            }),
          ]),
        ]
      ),
      _c("van-action-sheet", {
        attrs: { actions: _vm.downloadActions, "cancel-text": "取消" },
        on: { select: _vm.onDownloadSelect },
        model: {
          value: _vm.showDownloadSheet,
          callback: function ($$v) {
            _vm.showDownloadSheet = $$v
          },
          expression: "showDownloadSheet",
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }